<div class="flex flex-col w-[250px]">
  <div class="flex w-full justify-between border border-gray-20 bg-gray-30 px-2 py-1 rounded-t">
    <span class="text-xs"> {{ asset?.code ?? '' }}</span>
    <span class="text-xs"> {{ asset?.orderNumber ?? '' }}</span>
  </div>
  <div class="relative border border-gray-20 w-full h-[250px] overflow-hidden shadow-lg">
    <img
      class="w-full h-full object-cover rounded"
      [src]="
        (service.getPictureUrl(asset?.id, isPageTemporary, tenantPassword) | authImage | async) ||
        'assets/images/no-picture.jpg'
      "
    />

    <div
      *ngIf="!(asset?.isActive ?? true)"
      class="absolute -left-[35px] bottom-[42%] h-[33px] flex flex-center w-[320px] transform -rotate-[32deg] text-center text-white text-sm font-bold"
      [ngClass]="asset?.isActive ?? false ? 'bg-[#4DC34380]' : 'bg-[#FF495B80]'"
    >
      {{
        (asset?.isActive ?? false ? 'RegisterService::Active' : 'RegisterService::InActive')
          | abpLocalization
      }}
    </div>
  </div>
  <div
    class="flex flex-center w-full text-white text-sm text-center rounded-b py-[4px]"
    [ngClass]="asset?.assetType === AssetTypes.OWNED ? 'bg-green' : 'bg-red'"
  >
    {{ asset?.assetType ? formatAssetType(asset.assetType) : '' }}
  </div>
  <div class="flex flex-col !gap-3 mt-2" *ngIf="asset?.assetType === AssetTypes.HIRED">
    <div>
      <label class="form-label text-xs" for="asset-DateHired">
        {{ 'RegisterService::DateHired' | abpLocalization }}
      </label>
      <input
        id="asset-DateHired"
        [value]="
          asset?.dateHired ? (asset.dateHired | date : getShortDateFormat(configState)) : null
        "
        class="form-control bg-gray-30 !py-2"
        maxlength="64"
        readOnly
      />
    </div>
    <div>
      <label class="form-label text-xs" for="asset-HirePeriod">
        {{ 'RegisterService::HirePeriod' | abpLocalization }}
      </label>
      <input
        id="asset-HirePeriod"
        [value]="asset?.hireType ?? null"
        class="form-control bg-gray-30 !py-2"
        maxlength="64"
        readOnly
      />
    </div>
  </div>

  <!-- <div class="card-body" *ngIf="asset.assetType !== AssetTypes.OWNED">
    <h3 class="card-title mb-3">
      {{ 'RegisterService::AssetNextHire' | abpLocalization }}
    </h3>
    <div class="next-hire-wrapper mb-3">
      <div class="type-header-wrapper d-flex align-items-center gap-3">
        <label class="form-label">{{ 'RegisterService::AssetType' | abpLocalization }}</label>
        <label>{{
          asset.assetType
            ? ('RegisterService::Hired' | abpLocalization)
            : ('RegisterService::Owned' | abpLocalization)
        }}</label>
      </div>
    </div>
    <div class="mb-3 d-flex align-items-center gap-3" *ngIf="asset.assetType === AssetTypes.HIRED">
      <label class="form-label" for="asset-hire-date">
        {{ 'RegisterService::DateHired' | abpLocalization }}
      </label>
      <label for="form-label">{{ asset.dateHired | date : getShortDateFormat(configState) }}</label>
    </div>
    <div class="mb-3 d-flex align-items-center gap-3" *ngIf="asset.assetType === AssetTypes.HIRED">
      <label class="form-label">
        {{ 'RegisterService::HirePeriod' | abpLocalization }}
      </label>
      <label>{{ asset.hireType }}</label>
    </div>
    <div class="mb-3 d-flex align-items-center gap-3" *ngIf="asset.assetType === AssetTypes.HIRED">
      <label class="form-label" for="next-hire-date">
        {{ 'RegisterService::NextHirePeriod' | abpLocalization }}
      </label>
      <label for="form-label">{{
        asset.nextHireDate | date : getShortDateFormat(configState)
      }}</label>
    </div>
  </div> -->
</div>
